import get from 'lodash.get';

const getDomain = (rootState) => get(rootState, 'config.auth-gateway.domain');

export default getDomain;
